import { alpha } from "@mui/material/styles";

// chip.background.default/colorText.default do theme e um cinza quase transparente (~12% de
// opacidade) - ilegivel tanto contra fundo escuro (texto sem contraste) quanto contra fundo claro
// (chip some dentro da linha/paper). Como text.primary sempre tem contraste garantido contra
// background.paper (o MUI computa isso por padrao, mesmo em tema white-label), usamos ele como
// base do par neutro: fundo = text.primary com alpha, texto = text.primary solido. Alpha calibrado
// (WCAG: >=4.5:1 texto/fundo, >=3:1 fundo/linha) contra as cores reais de background.paper e
// secondary usadas nas linhas do DatagridComponent, nas duas variantes (par/impar)
const ALPHA_FUNDO = { dark: 0.38, light: 0.48 };

// Par fundo/texto neutro compartilhado por todo chip "sem status forte" da feature Versionamento
// (Ausente no cliente, Sem versão, Nunca coletado, Nada a atualizar, resultado sem sucesso/falha)
export default function corNeutraChip(theme) {
	return {
		background: alpha(theme.palette.text.primary, theme.palette.mode === "dark" ? ALPHA_FUNDO.dark : ALPHA_FUNDO.light),
		color: theme.palette.text.primary,
	};
}
